var _defs, _circle, _circle2, _circle3, _line, _line2;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgSymbolTeilenNeg = function SvgSymbolTeilenNeg(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    viewBox: "0 0 53.68 51.14",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#1d1d1b;}.cls-2,.cls-3{stroke:#fff;stroke-width:3px;}.cls-3{fill:none;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 9.92,
    cy: 25.51,
    r: 7.09
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 43.94,
    cy: 9.92,
    r: 7.09
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 43.94,
    cy: 41.1,
    r: 7.09
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 9.86,
    y1: 25.6,
    x2: 40.69,
    y2: 39.97
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 9.74,
    y1: 25.62,
    x2: 40.57,
    y2: 11.24
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSymbolTeilenNeg, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Symbol_Teilen_neg.36a43e76.svg";
export { ForwardRef as ReactComponent };